<template>
  <div class="panel-in-tab assessment-rules" :style="{ height: (maxTableHeight + 86) + 'px' }">
    <div style="height: 10px"></div>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button
          :type="editStatus ? 'warning' : 'primary'"
          size="mini"
          @click="edit"
        >{{ editStatus ? "保存" : "编辑" }}</el-button>
        <el-button type="primary" size="mini" @click="cancel" v-if="editStatus">取消</el-button>
      </template>
      <div v-loading="loading">
        <div
          v-for="(table, index) in tableDataSum"
          :key="index"
          style="margin: 10px; border: 1px solid #eee; padding: 0 10px; border-radius: 5px"
        >
          <div class="title">
            <strong>{{ tbaleName[index] }}</strong>
          </div>
          <el-table :data="table" border v-if="tableReload">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              show-overflow-tooltip
              v-for="item in propList[index]"
              :min-width="item.width"
              :key="item.prop"
              align="center"
              :width="item.prop == 'ruleDesc' ? '420px' : ''"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    (!scope.row.columnType && !editStatus) ||
                    scope.column.label == '指标'
                  "
                >
                  {{ scope.row[item.prop] | cellvalFormat }}
                </span>
                <el-input
                  autosize
                  type="textarea"
                  v-model="scope.row[scope.column.property]"
                  size="mini"
                  @focus="focus(scope)"
                  @input="input($event, scope)"
                  @blur="onBlur(scope)"
                  v-else
                />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" prop="column7" v-if="editStatus" width="100">
              <template slot-scope="scoped">
                <el-link
                  type="primary"
                  :underline="false"
                  @click="add(scoped, index + 1)"
                  v-if="!scoped.row.columnType"
                >新增</el-link>
                <el-link
                  type="primary"
                  :underline="false"
                  @click="addConfirm(scoped, index + 1)"
                  v-else
                >确定</el-link>
                <el-link
                  type="danger"
                  :underline="false"
                  @click="delRow(scoped, index + 1)"
                  style="margin-left: 10px"
                >删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div style="height: 16px"></div>
        </div>
      </div>
    </table-panel>
  </div>
</template>

<script>
import mixin from "./customProps.mixin";
import tableMixin from '@/utils/tableMixin';
import { debounce } from '@/utils/index';

export default {
  components: {},
  mixins: [mixin, tableMixin],
  data() {
    return {
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      tableData6: [],
      rowData: {},
      editStatus: false,
      tableReload: true,
      addType: true,
      hasChange: false,
      originData: null,
      addCloumnType: true,
      columnRow: [],
      addIndex: '',
      loading: false,
      tbaleName: ['达成率', '超卖率', '超卖产品比例', '超卖产品数', '积压产品比例', '积压产品数'],
      tableDataSum: [],
    };
  },
  computed: {},
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      this.addType = true;
      this.tableData = null;
      let res = await this.$q.preSalePlan.assessmentRulesList({});
      if (res.success && res.data) {
        this.tableData1 = res.data.achievementRate;
        this.tableData2 = res.data.oversoldRate;
        this.tableData3 = res.data.oversoldProportion;
        this.tableData4 = res.data.oversoldProCount;
        this.tableData5 = res.data.backlogProportion;
        this.tableData6 = res.data.backlogProCount;
        this.tableDataSum = [this.tableData1, this.tableData2, this.tableData3, this.tableData4, this.tableData5, this.tableData6];
      } else {
        this.tableData1 = [];
        this.tableData2 = [];
        this.tableData3 = [];
        this.tableData4 = [];
        this.tableData5 = [];
        this.tableData6 = [];
      }
      this.loading = false;
    },
    cancel() {
      this.editStatus = false;
      this.init();
    },
    edit() {
      this.editStatus = !this.editStatus;
      if (!this.editStatus) {
        let data = [
          ...this.tableData1,
          ...this.tableData2,
          ...this.tableData3,
          ...this.tableData4,
          ...this.tableData5,
          ...this.tableData6,
        ];
        this.$q.preSalePlan.updateAssessmentRule({ data: data })
          .then(res => {
            if (res.code == 200) {
              this.$message.success('编辑成功');
              this.init();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            this.init();
          });
      }
    },
    focus(data, $event) {
      this.originData = data.row[data.column.property];
    },
    input(e, scope) {
      var row = scope.row;
      scope.row[scope.column.property] = scope.row[scope.column.property].replace(/[^\d]/g, '');
      var ruleDesc = '';
      if (row.ruleType == 1) {
        if (!row.limitLower && !row.limitExtra && !row.addScoreOfProportion) {
          ruleDesc = `达成率<${row.limitUpper || 0}%,得${row.scoreBase || 0}分`;
        } else if (!row.limitUpper && !row.limitExtra && !row.addScoreOfProportion) {
          ruleDesc = `达成率≥${row.limitLower || 0}%,得${row.scoreBase || 0}分`;
        } else if (!row.limitExtra && !row.addScoreOfProportion) {
          ruleDesc = `${row.limitUpper || 0}%>达成率≥${row.limitLower || 0}%,得${row.scoreBase || 0}分`;
        } else if (!row.limitUpper) {
          ruleDesc = `达成率≥${row.limitLower || 0}%,得${row.scoreBase || 0}分,超过${row.limitExtra || 0}%一个百分点额外加${row.addScoreOfProportion || 0}分`;
        } else if (!row.limitLower) {
          ruleDesc = `达成率<${row.limitUpper || 0}%,得${row.scoreBase || 0}分,超过${row.limitExtra || 0}%一个百分点额外加${row.addScoreOfProportion || 0}分`;
        } else {
          ruleDesc = `${row.limitUpper || 0}%>达成率≥${row.limitLower || 0}%,得${row.scoreBase || 0}分,超过${row.limitExtra || 0}%一个百分点额外加${row.addScoreOfProportion || 0}分`;
        }
        row.ruleDesc = ruleDesc;
      } else if (row.ruleType == 2) {
        if (!row.limitUpper && !row.scoreExtra && !row.scoreExtraDel) {
          ruleDesc = `超卖率≥${row.limitLower || 0}%,得${row.scoreBase || 0}分`;
        } else if (!row.limitLower && !row.scoreExtra) {
          ruleDesc = `超卖率<${row.limitUpper || 0}%,得${row.scoreBase || 0}分`;
        } else if (!row.scoreExtra && !row.scoreExtraDel) {
          ruleDesc = `${row.limitUpper || 0}%>超卖率≥${row.limitLower || 0}%,得${row.scoreBase || 0}分`;
        } else if (!row.limitUpper && !row.scoreExtraDel) {
          ruleDesc = `超卖率≥${row.limitLower || 0}%,得${row.scoreBase || 0}分,额外加${row.scoreExtra || 0}分,共得${(parseInt(row.scoreBase) || 0) + (parseInt(row.scoreExtra) || 0)}分`;
        } else if (!row.limitLower && !row.scoreExtraDel) {
          ruleDesc = `超卖率<${row.limitUpper || 0}%,得${row.scoreBase || 0}分,额外加${row.scoreExtra || 0}分,共得${(parseInt(row.scoreBase) || 0) + (parseInt(row.scoreExtra) || 0)}分`;
        } else if (!row.limitUpper && row.scoreExtraDel) {
          ruleDesc = `超卖率≥${row.limitLower || 0}%,得${row.scoreBase || 0}分,${row.scoreExtra ? `额外加${row.scoreExtra || 0}分,` : ''}扣${row.scoreExtraDel || 0}分,共得${((parseInt(row.scoreBase) || 0) + (parseInt(row.scoreExtra) || 0) - parseInt(row.scoreExtraDel) || 0)}分`;
        } else if (!row.limitLower && row.scoreExtraDel) {
          ruleDesc = `超卖率<${row.limitUpper || 0}%,得${row.scoreBase || 0}分,${row.scoreExtra ? `额外加${row.scoreExtra || 0}分,` : ''}扣${row.scoreExtraDel || 0}分,共得${((parseInt(row.scoreBase) || 0) + (parseInt(row.scoreExtra) || 0) - parseInt(row.scoreExtraDel) || 0)}分`;
        } else {
          ruleDesc = `${row.limitUpper || 0}%>超卖率≥${row.limitLower || 0}%,得${row.scoreBase || 0}分,${row.scoreExtra ? `额外加${row.scoreExtra || 0}分,` : ''}扣${row.scoreExtraDel || 0}分,共得${((parseInt(row.scoreBase) || 0) + (parseInt(row.scoreExtra) || 0) - parseInt(row.scoreExtraDel) || 0)}分`;
        }
        row.ruleDesc = ruleDesc;
      } else if (row.ruleType == 3) {
        if (!row.limitUpper) {
          ruleDesc = `超卖产品比例≥${row.limitLower || 0}%,得${row.scoreBase || 0}分`;
        } else if (!row.limitLower) {
          ruleDesc = `超卖产品比例<${row.limitUpper || 0}%,得${row.scoreBase || 0}分`;
        } else {
          ruleDesc = `${row.limitUpper || 0}%>超卖产品比例≥${row.limitLower || 0}%,得${row.scoreBase || 0}分`;
        }
        row.ruleDesc = ruleDesc;
      } else if (row.ruleType == 4) {
        if (!row.limitLower && !row.proportion) {
          ruleDesc = `销售预估调整量${row.limitUpper || 0}套以下的产品`;
        } else if (!row.limitUpper && !row.proportion) {
          ruleDesc = `销售预估调整量${row.limitLower || 0}套以上的产品`;
        } else if (!row.limitUpper) {
          ruleDesc = `销售预估调整量${row.limitLower || 0}套以上的产品,超卖量在${row.proportion || 0}%及以上`;
        } else if (!row.limitLower) {
          ruleDesc = `销售预估调整量${row.limitUpper || 0}套以下的产品,超卖量在${row.proportion || 0}%及以上`;
        } else {
          ruleDesc = `销售预估调整量${row.limitLower || 0}套 ~ ${row.limitUpper || 0}套的产品,超卖量在${row.proportion || 0}%及以上`;
        }
        row.ruleDesc = ruleDesc;
      } else if (row.ruleType == 5) {
        if (!row.limitUpper) {
          ruleDesc = `积压产品比例≥${row.limitLower || 0}%,得${row.scoreBase || 0}分`;
        } else if (!row.limitLower) {
          ruleDesc = `积压产品比例<${row.limitUpper || 0}%,得${row.scoreBase || 0}分`;
        } else {
          ruleDesc = `${row.limitUpper || 0}%>积压产品比例≥${row.limitLower || 0}%,得${row.scoreBase || 0}分`;
        }
        row.ruleDesc = ruleDesc;
      } else if (row.ruleType == 6) {
        if (!row.limitLower && !row.proportion) {
          ruleDesc = `销售预估调整量${row.limitUpper || 0}套以下的产品`;
        } else if (!row.limitUpper && !row.proportion) {
          ruleDesc = `销售预估调整量${row.limitLower || 0}套以上的产品`;
        } else if (!row.limitUpper) {
          ruleDesc = `销售预估调整量${row.limitLower || 0}套以上的产品,积压量在${row.proportion || 0}%及以上`;
        } else if (!row.limitLower) {
          ruleDesc = `销售预估调整量${row.limitUpper || 0}套以下的产品,积压量在${row.proportion || 0}%及以上`;
        } else {
          ruleDesc = `销售预估调整量${row.limitLower || 0}套 ~ ${row.limitUpper || 0}套的产品,积压量在${row.proportion || 0}%及以上`;
        }
        row.ruleDesc = ruleDesc;
      }
      this.hasChange = e !== this.originData;
    },
    onBlur(scope) {
      this.columnRow = scope.row;
      if (!this.hasChange) return;
      this.hasChange = false;
      this.originData = null;
    },
    addConfirm: debounce(function(scope, index) {
      this.$q.preSalePlan.addAssessmentRule({ data: { ...scope.row, ruleType: index } })
        .then(res => {
          if (res.code == 200) {
            this.$message.success('新增成功');
            this.init();
          } else {
            this.$message.error(res.message);
          }
        });
    }, 500),
    add(data, index) {
      if (!this.addType) {
        this.$message.error('请填写完后在新增');
        return;
      }
      this.tableReload = false;
      this.addType = false;
      let row = JSON.parse(JSON.stringify(data.row));
      row.dataId = null;
      if (data.row.ruleType == 1) {
        this.tableData1.splice(data.$index + 1, 0, { ...row, columnType: 5 });
      } else if (data.row.ruleType == 2) {
        this.tableData2.splice(data.$index + 1, 0, { ...row, columnType: 5 });
      } else if (data.row.ruleType == 3) {
        this.tableData3.splice(data.$index + 1, 0, { ...row, columnType: 5 });
      } else if (data.row.ruleType == 4) {
        this.tableData4.splice(data.$index + 1, 0, { ...row, columnType: 5 });
      } else if (data.row.ruleType == 5) {
        this.tableData5.splice(data.$index + 1, 0, { ...row, columnType: 5 });
      } else if (data.row.ruleType == 6) {
        this.tableData6.splice(data.$index + 1, 0, { ...row, columnType: 5 });
      }
      this.addCloumnType = true;
      this.tableReload = true;
    },
    async delRow(data, index) {
      let status = await this.$confirm("是否确认删除该条数据？",'提示', {type: 'warning'});
      if (status !== "confirm") return;
      if (this.addCloumnType && data.row.columnType) {
        if (index == 1) {
          this.tableData1.splice(data.$index, 1);
        } else if (index == 2) {
          this.tableData2.splice(data.$index, 1);
        } else if (index == 3) {
          this.tableData3.splice(data.$index, 1);
        } else if (index == 4) {
          this.tableData4.splice(data.$index, 1);
        } else if (index == 5) {
          this.tableData5.splice(data.$index, 1);
        } else if (index == 6) {
          this.tableData6.splice(data.$index, 1);
        }
        this.addType = true;
        return;
      }
      let res = await this.$q.preSalePlan.delAssessmentRule({
        fragment: [data.row.dataId],
      });
      if (res.success) {
        this.$message.success("删除成功");
      } else {
        this.$message.fail("删除失败");
      }
      this.init();
    },
  },
  filters: {
    cellvalFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "/";
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

.assessment-rules
  overflow-y auto

  >>> .main-area
    height 100%
    overflow visible

.title
  color #444
  margin 10px 0

.title strong
  font-size 16px

>>> .el-icon-warning-outline
  font-size 14px
  color #777
</style>
